export const getHotelLocation = ({ province, location, country, includeCountry }) => {
    const locationStr = province && province !== location ? `${location}, ${province}` : location;
    return includeCountry && country && province !== country ? `${locationStr}, ${country} ` : locationStr;
};
